import React, { memo } from 'react'
import { InquireNowBtnProps } from '../Properties.types'
import { isPMaxProperty } from './InquireNowBtn.utils'

function InquireNowBtn({
  btnClass,
  children,
  fn,
  propertyName,
}: InquireNowBtnProps): JSX.Element {
  return (
    <button
      type="button"
      className={btnClass || `inquire-now-btn`}
      onClick={() => {
        if (fn) {
          fn()
        }
        if (propertyName) {
          isPMaxProperty(propertyName)
        }
      }}
    >
      {children || 'Submit'}
    </button>
  )
}

export default memo(InquireNowBtn)
